import cx from 'classnames'

import MenuItem from 'common/components/catalog/MenuItem'
import MenuButton from 'common/components/menuButton'
import { errorToast } from 'common/components/toastNotification'
import Tooltip from 'common/components/Tooltip'
import { formatPastDate } from 'common/helpers/date'
import { Bin, Duplicate, Edit, MoreOptionsVertical } from 'common/icons'

type Props = {
  name: string
  createdDate: string
  isSelected: boolean
  onClick: () => void
}

const ReportCard = ({ name, createdDate, isSelected, onClick }: Props) => {
  return (
    <div
      className={cx(
        'flex justify-between items-center p-4 rounded-sm hover:bg-gold-300',
        {
          'bg-gold-40': !isSelected,
          'bg-yellow-200 border-l-2 border-black': isSelected,
        }
      )}
      onClick={onClick}
    >
      <div>
        <p className="uppercase font-medium">{name}</p>
        <p className="text-xxs">{formatPastDate(createdDate)}</p>
      </div>
      <MenuButton
        portal
        buttonProps={{
          'aria-label': 'More options',
          onClick: (e) => e.stopPropagation(),
          children: (
            <Tooltip
              overlay="Options"
              children={<MoreOptionsVertical size={6} />}
            />
          ),
        }}
        options={
          <>
            <MenuItem
              key="rename"
              onSelect={() => errorToast('Not implemented yet')}
              aria-label="Rename"
            >
              <Edit size={4} className="mr-4" />
              Rename
            </MenuItem>
            <MenuItem
              key="duplicate"
              onSelect={() => errorToast('Not implemented yet')}
              aria-label="Duplicate"
            >
              <Duplicate size={4} className="mr-4" />
              Duplicate
            </MenuItem>
            <MenuItem
              key="remove"
              onSelect={() => errorToast('Not implemented yet')}
              aria-label="Remove"
            >
              <Bin size={4} className="mr-4" />
              Remove
            </MenuItem>
          </>
        }
      />
    </div>
  )
}

export default ReportCard
